module.exports = __webpack_public_path__ + "media/images/page-first-2053f2f8e44051e80e6881d83505cc05.svg";